// import toast from "react-hot-toast";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({
	component: Component,
	isAuthenticated,
	hasRight,
	...rest
}) => {
	const renderComponent = ({ location, ...props }) => {
		// User is authenticated and has the required rights
		if (isAuthenticated && hasRight) {
			return <Component {...props} />;
		}

		// User is authenticated but doesn't have the required rights
		if (isAuthenticated && !hasRight) {
			return <Redirect to="/access-denied" />;
		}

		// User is not authenticated, redirect to login with intended URL
		const intendedUrl = encodeURIComponent(location.pathname + location.search);
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?intended=${intendedUrl}`,
					state: { from: location },
				}}
			/>
		);
	};

	return (
		<Route
			render={renderComponent}
			{...rest}
		/>
	);
};

export default PrivateRoute;
